import { APIClient } from '../../helpers/api_helper';
const AxiosClient = new APIClient()
const contactCreate = payload => AxiosClient.post('/contact', payload);
const getContactList = (params) => AxiosClient.get('/contact', params);
const showContact = (id, query) => AxiosClient.get(`/contact/${id}`, {...query});
const updateContact = (id, payload) => AxiosClient.put(`/contact/${id}`, { ...payload });
const deleteContact = (id, payload) => AxiosClient.delete(`/contact/${id}`, { data: payload });

export {
    contactCreate,
    getContactList,
    updateContact,
    deleteContact
}